module.exports = __webpack_public_path__ + "1.0.0-fa265927/img/offline-collector-4.5f4c0520.svg";